import { render } from "./Premios.vue?vue&type=template&id=e464117c&scoped=true"
import script from "./Premios.vue?vue&type=script&lang=js"
export * from "./Premios.vue?vue&type=script&lang=js"

import "./Premios.vue?vue&type=style&index=0&id=e464117c&lang=css"
import "./Premios.vue?vue&type=style&index=1&id=e464117c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e464117c"]])

export default __exports__